import {
  EConnectionStatus,
} from './rendering-engine-view.ts';

const connectionStatus: Record<EConnectionStatus, string> = {
  [EConnectionStatus.CONNECTING]: 'Pripájanie',
  [EConnectionStatus.CONNECTED]: 'Pripojené',
  [EConnectionStatus.WAITING_FOR_DATA]: 'Čakanie na dáta',
  [EConnectionStatus.ERROR]: 'Chyba',
};

export default {
  connectionStatus,
  latestUpdate: 'Posledná aktualizácia',
  enterFullscreen: 'Celá obrazovka',
  exitFullscreen: 'Zatvoriť celú obrazovku',
};
